/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';
import { IldsFooterProps } from '../lds-footer.data';

const TermsOfService: React.FC<IldsFooterProps> = ({ termsOfUse, privacyPolicy, termsTitle, privacyTitle, onClick }) => {
    return (
        <div className='terms'>
            <a
                className='term'
                onClick={() => (termsOfUse && termsOfUse.PolicyType ? onClick(termsOfUse.PolicyType) : '')}
                target='_blank'
                rel='noreferrer'
                style={{ cursor: 'pointer' }}
            >
                {termsTitle || termsOfUse?.DESCRIPTION || termsOfUse?.Description || termsOfUse?.PolicyType}
            </a>
            <a
                className='term'
                onClick={() => (privacyPolicy && privacyPolicy.PolicyType ? onClick(privacyPolicy.PolicyType) : '')}
                target='_blank'
                rel='noreferrer'
                style={{ cursor: 'pointer' }}
            >
                {privacyTitle || privacyPolicy?.DESCRIPTION || privacyPolicy?.Description || privacyPolicy?.PolicyType}
            </a>
            <div id='teconsent'></div>
        </div>
    );
};

export default TermsOfService;
